import { Grid, Card, CardContent, makeStyles } from '@material-ui/core'
import React from 'react'
import { ChromePicker, ColorChangeHandler, ChromePickerProps } from 'react-color'

const useStyles = makeStyles(theme => ({
  card: {
    maxWidth: 400,
    boxShadow: theme.shadows[3],
    borderRadius: 10,
    margin: 10,
  },
  cardContent: {
    paddingBottom: '0 !important',
  },
  colorPickerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
  },
  colorPickerLabel: {
    fontSize: 18,
    color: '#757575',
    marginBottom: theme.spacing(1),
  },
  customChromePicker: {
    boxShadow: 'none !important',
  },
}))

interface CustomColorPickerProps {
  label: string
  color: string
  handler: (color: string) => void
}

const ColorPicker: React.FC<CustomColorPickerProps> = ({ label, color, handler }) => {
  const classes = useStyles()
  const TypedChromePicker = ChromePicker as React.ComponentType<ChromePickerProps>

  const handleColorChange: ColorChangeHandler = colorResult => {
    handler(colorResult.hex)
  }

  return (
    <Grid>
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          <div className={classes.colorPickerContainer}>
            <div className={classes.colorPickerLabel}>{label}</div>
            <TypedChromePicker
              color={color}
              onChangeComplete={handleColorChange}
              className={classes.customChromePicker}
              disableAlpha
            />
          </div>
        </CardContent>
      </Card>
    </Grid>
  )
}

export { ColorPicker }
